module.exports = __webpack_public_path__ + "img/icon_estadual.fcbc88c8.png";